export const environment = {
  production: false,
  apiUrl: 'https://api.dev.sapptradingpro.com/api/v1',
  apiTestUrl: 'http://57.128.245.130:8083/api/v1',
};
